// extracted by mini-css-extract-plugin
module.exports = {"base":"TaskBar_base__2IrKq","barContent":"TaskBar_barContent__2QOKG","dropdownTrigger":"TaskBar_dropdownTrigger__2f833"};